import React from 'react'
import { Box, Stack, Typography } from '@mui/material'

const AccountPageIntro = ({ action, children }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    alignItems={{ xs: 'flex-start', sm: 'center' }}
    justifyContent="space-between"
    spacing={1.5}
    sx={{ mb: 3 }}
  >
    <Typography color="text.secondary" variant="body2" sx={{ fontSize: 14 }}>
      {children}
    </Typography>
    {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
  </Stack>
)

export default AccountPageIntro
